import { render, staticRenderFns } from "./SelfAdminSubscriptionList.vue?vue&type=template&id=6beb32a4&"
import script from "./SelfAdminSubscriptionList.vue?vue&type=script&lang=js&"
export * from "./SelfAdminSubscriptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports